import $ from 'jquery';
import Actions from './modules/actions';
import Mutations from './modules/mutations';
import Getters from './modules/getters';
import { namespace } from './modules/env';

const actionInstance = new Actions();
const mutationInstance = new Mutations();
const getterInstance = new Getters();

const scrollToProperty = () => {
  const $target = $('html,body');
  const $property = $('#js-property');
  const marginTop = 40;

  $target.animate({ scrollTop: $property.offset().top - marginTop });
};

(() => {
  const getLoadJson = (filename, callback) => {
    const rawFile = new XMLHttpRequest();
    rawFile.overrideMimeType('application/json');
    rawFile.open('GET', filename, true);
    rawFile.onreadystatechange = function () {
      if (rawFile.readyState === 4 && rawFile.status == '200') {
        callback(rawFile.responseText);
      }
    };
    rawFile.send(null);
  };

  const getJsonFile = async () => {
    await getLoadJson(
      `${window.location.href.replace('/index.html', '')}/config/stations.json`,
      (text) => {
        if (
          sessionStorage.getItem(namespace.STATIONS_JSON) === undefined ||
          sessionStorage.getItem(namespace.STATIONS_JSON) === null
        ) {
          sessionStorage.setItem(namespace.STATIONS_JSON, text);
        } else {
          sessionStorage.removeItem(namespace.STATIONS_JSON);
          sessionStorage.setItem(namespace.STATIONS_JSON, text);
        }
      }
    );
    await getLoadJson(
      `${window.location.href.replace(
        '/index.html',
        ''
      )}/config/conditions.json`,
      (text) => {
        if (
          sessionStorage.getItem(namespace.CONDITION_JSON) === undefined ||
          sessionStorage.getItem(namespace.CONDITION_JSON) === null
        ) {
          sessionStorage.setItem(namespace.CONDITION_JSON, text);
        } else {
          sessionStorage.removeItem(namespace.CONDITION_JSON);
          sessionStorage.setItem(namespace.CONDITION_JSON, text);
        }
      }
    );
  };

  getJsonFile();

  getterInstance.setSlickCarousel();
  actionInstance.getInventoryProperty();
})();

$(document).on('click', '.js-prev-button', function () {
  mutationInstance.clickPrevButton();
  scrollToProperty();
});
$(document).on('click', '.js-next-button', function () {
  mutationInstance.clickNextButton();
  scrollToProperty();
});
$(document).on('click', '.js-pagination-button', function (e) {
  mutationInstance.transitionViewPropertyData(Number(e.target.innerText));
  scrollToProperty();
});

$(document).on('click', '.js-station-item', function (e) {
  mutationInstance.getSelectStationProperty(
    e.currentTarget.dataset.value,
    e.currentTarget.dataset.rid
  );
});
$(document).on('change', '.js-check-station-clear', function () {
  mutationInstance.allClearSelectStation();
});
$(document).on('change', '.js-check-station-all', function () {
  mutationInstance.allSelectStation();
});
$(document).on('click', '.js-narrowing-button', function () {
  mutationInstance.narrowingStationProperty();
});

$(document).on('change', '.js-property-sort', function (e) {
  mutationInstance.changeSortData(e.target.value);
});

// 他の沿線を見る
(() => {
  const $otherRailroad = $('#js-other-railroad');

  $.getJSON(
    `${window.location.href.replace('/index.html', '')}/config/navigation.json`,
    (data) => {
      for (let item of data.ListOfLines) {
        $otherRailroad.append(`
        <div class="other-railroad-list-item">
          <div class="title">${item.Prefecture}</div>
          <div class="list">
            ${item.RailwayList.map(
              (_item) =>
                `<div class="link"><a href="${_item.url}">${_item.name}</a></div>`
            ).join('')}
          </div>
        </div>
      `);
      }
    }
  );
})();
